import { JSX } from 'react';

export type ProgramaticallyLinkParams = Pick<JSX.IntrinsicElements['a'], 'target' | 'rel' | 'href' | 'onClick'>;

export function makeProgramaticallyLinkClick({
  target = '_blank',
  rel = 'noopener noreferrer',
  href,
  onClick,
}: ProgramaticallyLinkParams) {
  if (!document) return;
  if (!href) return;

  const link = document.createElement('a');
  link.target = target;
  link.rel = rel;
  link.href = href;
  link.ariaHidden = 'true';
  link.onclick = evt => {
    onClick?.(evt as unknown as Parameters<typeof onClick>[0]);
  };
  link.click();
}
